import React from 'react'
import { useEffect,useState } from 'react';
import Searchbar2 from '../../../components/forms/searchbar2';

const List = ({Values}) => {
    const [Filter,setFilter] = useState(Values);
    useEffect(()=>{
        setFilter(Values)
    },[Values])
  return (
    <div className='form_table_container'>
      <Searchbar2 Values={Values} setFilter={setFilter}/>
      <table>
        <thead>
          <tr className='title'>
            <td className='form_item_row_container_itemfull' style={{width:'20%'}}>
              <p>Ticket#</p>
            </td>
            <td className='form_item_row_container_item' style={{width:'20%'}}>
              <p>Subject</p>
            </td>
            <td className='form_item_row_container_item' style={{width:'40%'}}>
              <p>Message</p>
            </td>
            <td className='form_item_row_container_item' style={{width:'20%'}}>
              <p>Date</p>
            </td>
          </tr>
        </thead>
        <tbody>
        {
          Filter.map((item,Index)=>{
            return(
                <tr key={Index}>
                    <td className='form_item_row_container_item' style={{width:'20%'}}>
                        <p>TXK-2023-{item.id}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'20%'}}>
                        <p>{item.subject}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'40%'}}>
                        <p>{item.message}</p>
                    </td>
                    <td className='form_item_row_container_item' style={{width:'20%'}}>
                        <p>{item.date}</p>
                    </td>
                </tr>
            );
          })
        }
        </tbody>
      </table>
    </div>
  )
}

export default List
